import { NgModule } from '@angular/core';
import { ProductAssortmentsListComponent } from './product-assortments-list.component';
import {ProductClassificationModule} from '../../../shared/product-classification/product-classification.module';
import {Route, RouterModule} from '@angular/router';

export const productAssortmentRoutes: Route[] = [
    {
        path: '',
        component: ProductAssortmentsListComponent
    }
];

@NgModule({
  declarations: [ProductAssortmentsListComponent],
    imports: [
        ProductClassificationModule,
        RouterModule.forChild(productAssortmentRoutes)
    ]
})
export class ProductAssortmentsModule { }
